<template>
  <pa-grid class="pa-draggable">
    <draggable tag="ul" v-model="draggs" class="pa-draggable__list">
      <pa-row
        class="pa-draggable__row"
        :class="!!item.destroy ? 'pa-draggable__row--disabled' : ''"
        v-for="(item, index) in draggs"
        :key="index"
      >
        <pa-col :col="null" class="pa-draggable__col">
          <li class="pa-draggable__action" @click="$emit('edit', item)">
            <icon-arrow-down />
          </li>
        </pa-col>
        <pa-col class="pa-draggable__col">
          <span> {{ item.name }} {{ item.destroy ? "- DELETE" : "" }} </span>
        </pa-col>
      </pa-row>
    </draggable>
  </pa-grid>
</template>

<script>
import draggable from "vuedraggable";
import IconArrowDown from "@gocasebr/go-shared/dist/arrow-down/ArrowDown";

export default {
  components: { draggable, IconArrowDown },
  props: {
    value: {
      type: Array,
      default: () => {},
    },
    actions: {
      type: Array,
      default: () => {},
    },
  },
  data() {
    return {
      draggs: this.value,
    };
  },
  watch: {
    value(nval) {
      if (nval !== this.draggs) this.draggs = nval;
    },
    draggs(nval) {
      if (nval) {
        nval.forEach((e, i) => (e.order = i));
        this.$emit("input", nval);
        this.$emit("update");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/variables.scss";

.pa-draggable {
  .pa-draggable__action {
    width: 16px;
    display: flex;
    cursor: pointer;
    fill: $color_line;
  }

  .pa-draggable__list {
    list-style: none;
    padding: 0;
  }

  .pa-draggable__row {
    display: flex;
    align-items: center;
    padding: 6px;
    margin: 6px 0;
    cursor: grab;
    background: $sixth_color;
    color: $color_line;
    font-weight: lighter;

    .pa-draggable__col {
      padding-bottom: 0;
    }
  }

  .pa-draggable__row--disabled {
    background: $color_gray_text;
  }
}
</style>
